export const CUBE_ID = 'facts_slides';
export const REPORT_ID = 'aquarium-area';
export const REPORT_APE_ID = 'aquarium-area-ape';